import React from 'react';

import usePrefix from 'utils/usePrefix';
import { LanguagesList } from 'utils/api/users';
import useDefaultFormikValue from 'utils/useDefaultFormikValue';
import FormikSelect, { FormikSelectOption } from 'components/FormikSelect';

const languageOptions: Array<FormikSelectOption<LanguagesList>> = [
  { value: 'PL', label: 'PL' },
  { value: 'EN', label: 'EN' },
  { value: 'CZ', label: 'CZ' },
  { value: 'SK', label: 'SK' },
  { value: 'UA', label: 'UA' },
];

interface Props {
  name: string;
  margin?: string;
  isClearable?: boolean;
  isDisabled?: boolean;
  defaultValue?: LanguagesList;
}

const LanguageSelect: React.FC<Props> = ({
  name,
  margin = '0',
  isClearable = false,
  isDisabled = false,
  defaultValue,
}) => {
  const t = usePrefix('General');

  useDefaultFormikValue<LanguagesList>(name, defaultValue);

  return (
    <FormikSelect<LanguagesList>
      name={name}
      label={t('language')}
      placeholder={t('choose_language')}
      options={languageOptions}
      margin={margin}
      isDisabled={isDisabled}
      isClearable={isClearable}
    />
  );
};

export default LanguageSelect;
